export const LINE_SCOPE_OPTIONS = {
  liff: 'LINE LIFF',
  'messaging-api': 'LINE Messaging API',
}

export const TUNNEL_SERVICE_OPTIONS = {
  ngrok: 'ngrok',
  custom: 'Custom URL',
}

export const LIFF_APP_VIEW_TYPE_OPTIONS = {
  full: 'Full',
  tall: 'Tall',
  compact: 'Compact',
}

export const LIFF_APP_SCOPE_OPTIONS = {
  openid: 'OpenID',
  email: 'Email',
  profile: 'Profile',
  'chat_message.write': 'Chat Message Write',
}

export const LIFF_APP_BOT_PROMPT_OPTIONS = {
  normal: 'Normal',
  aggressive: 'Aggressive',
  none: 'None',
}
